import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    OnInit,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { DefaultImageDirectiveModule } from '@pragma/directives';
import { UserDto } from '@pragma/dto';
import { LayoutService, NotificationsService, UserService } from '@pragma/services';
import { MenuItem } from 'primeng/api';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { ToastModule } from 'primeng/toast';

@Component({
    standalone: true,
    selector: 'ngx-header',
    templateUrl: './header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    imports: [CommonModule, AvatarModule, MenuModule, ToastModule, DefaultImageDirectiveModule, ButtonModule]
})
export class HeaderComponent implements OnInit {
    user: UserDto | undefined;
    items!: MenuItem[];
    isDarkMode: boolean = false;
    currentLang: string;

    @ViewChild('menubutton') menuButton!: ElementRef;
    @ViewChild('topbarmenubutton') topbarMenuButton!: ElementRef;
    @ViewChild('topbarmenu') menu!: ElementRef;

    constructor(
        private _userService: UserService,
        private _translateService: TranslateService,
        private _cd: ChangeDetectorRef,
        private _notificationService: NotificationsService,
        public layoutService: LayoutService,
        private _router: Router
    ) {
        this.items = [];
        this.currentLang = this._translateService.currentLang || 'en';
    }

    ngOnInit(): void {
        this.subscribeToUser();
        this.initializeLanguage();

        this._translateService.onLangChange.subscribe((event: LangChangeEvent) => {
            this.currentLang = event.lang;
            this._cd.detectChanges();
        });
    }

    changeLanguage(lang: string): void {
        this._translateService.use(lang).subscribe(() => {
            localStorage.setItem('preferredLang', lang);
            this.currentLang = lang;
            this._cd.detectChanges();
        });
    }

    private subscribeToUser(): void {
        this._userService.user.subscribe({
            next: (user) => {
                this.user = user;
                this._cd.detectChanges();
            },
            error: () => {
                const title = this._translateService.instant('errors.user.subscription');
                const message = this._translateService.instant('errors.user.loadData');
                this._notificationService.displayError(title, message);
            }
        });
    }

    private initializeLanguage(): void {
        const prefferedLang = localStorage.getItem('preferredLang') || 'en';
        this.changeLanguage(prefferedLang);
    }

    navigateHome(): void {
        this._userService.getUser().subscribe((user) => {
            if (user?.userRoles.length === 1 && (user.userRoles[0].id === 6 || user.userRoles[0].id === 7)) {
                this._router.navigate(['/pages', 'support']);
            } else {
                this._router.navigate(['admin/users']);
            }
            this._cd.detectChanges();
        });
    }
}
